import { h, clear } from './dom.js';
import {
    saveNamed, loadNamed, deleteNamed, listNames,
    exportProjectFile, importProjectFile,
} from '../core/persistence.js';
import { exportProject, downloadBlob } from '../core/exporter.js';

export function mountProjectBar(ctx, slot) {
    clear(slot);

    const select = h('select.project-select');
    const refresh = () => {
        clear(select);
        select.appendChild(h('option', { value: '' }, '-- projects --'));
        for (const n of listNames()) select.appendChild(h('option', { value: n }, n));
    };
    refresh();

    const barsSel = h('select.bars-select', {
        title: 'Number of pattern loops to record',
    }, [2, 4, 8, 16].map(n => h('option', { value: String(n), selected: n === 4 }, `${n} bars`)));

    const exportBtn = h('button.btn.btn-primary', {
        onClick: async () => {
            const bars = parseInt(barsSel.value, 10);
            const name = (select.value || 'music-maker') + '.wav';
            exportBtn.disabled = true;
            const original = exportBtn.textContent;
            exportBtn.textContent = 'Recording…';
            try {
                const blob = await exportProject(ctx, { bars });
                downloadBlob(blob, name);
                exportBtn.textContent = 'Done ✓';
                setTimeout(() => { exportBtn.textContent = original; exportBtn.disabled = false; }, 800);
            } catch (e) {
                alert('Export failed: ' + e.message);
                exportBtn.textContent = original;
                exportBtn.disabled = false;
            }
        },
    }, 'Export WAV');

    // Hidden file input for project import.
    const importInput = h('input', {
        type: 'file', accept: 'application/json,.json', style: { display: 'none' },
        onChange: async (e) => {
            const file = e.target.files?.[0];
            if (!file) return;
            try {
                const snap = await importProjectFile(ctx, file);
                refresh();
                if (snap?.name) select.value = snap.name;
            } catch (err) {
                alert(`Couldn't import ${file.name}: ${err.message}`);
            }
            e.target.value = '';
        },
    });

    slot.appendChild(h('div.projectbar-inner', {}, [
        h('span.label', {}, 'Project'),
        h('button.btn', {
            onClick: () => {
                const name = prompt('Save project as:', select.value || 'untitled');
                if (!name) return;
                saveNamed(ctx, name);
                refresh();
                select.value = name;
            },
        }, 'Save'),
        select,
        h('button.btn', {
            onClick: () => {
                const name = select.value;
                if (!name) return;
                ctx.scheduler.stop();
                loadNamed(ctx, name);
            },
        }, 'Load'),
        h('button.btn.btn-danger', {
            onClick: () => {
                const name = select.value;
                if (!name) return;
                if (!confirm(`Delete project "${name}"?`)) return;
                deleteNamed(name);
                refresh();
            },
        }, 'Delete'),
        h('span.divider'),
        h('button.btn', {
            onClick: () => exportProjectFile(ctx, select.value || prompt('Export name:', 'untitled') || 'untitled'),
            title: 'Download a .json file you can re-import elsewhere',
        }, 'Export…'),
        h('button.btn', {
            onClick: () => importInput.click(),
            title: 'Import a .mmproj.json file',
        }, 'Import…'),
        h('button.btn', {
            onClick: async () => {
                try {
                    const resp = await fetch('/presets/cipher-cinematic.json');
                    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
                    const snap = await resp.json();
                    await importProjectFile(ctx, snap);
                    refresh();
                    select.value = snap.name || 'Cipher-Cinematic';
                } catch (err) {
                    alert(`Couldn't load demo: ${err.message}`);
                }
            },
            title: 'Load the bundled Cipher-Cinematic demo song',
        }, '★ Demo'),
        importInput,
        h('span.divider'),
        barsSel,
        exportBtn,
    ]));
}
